import Fingerprint2 from 'fingerprintjs2'

export function generateFingerprint(callback) {
  return new Fingerprint2().get(callback)
}



// WEBPACK FOOTER //
// ./src/services/fingerprint.js